
import { Accordion } from 'react-bootstrap'
import { useTranslation } from "react-i18next"

export function OnBoardingCandidateProfile() {
    const { t } = useTranslation()
    return (
        <Accordion className='onboarding'>
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.personalData')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentPersonalData.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentPersonalData.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <div><strong>{t('dashboard.onboardingCandidate.contentPersonalData.option1')}</strong></div>
                        <div className='mb-3'>{t('dashboard.onboardingCandidate.contentPersonalData.textOption1')}</div>
                        <div><strong>{t('dashboard.onboardingCandidate.contentPersonalData.option2')}</strong></div>
                        <div className='mb-3'>{t('dashboard.onboardingCandidate.contentPersonalData.textOption2')}</div>
                        <div><strong>{t('dashboard.onboardingCandidate.contentPersonalData.option3')}</strong></div>
                        <div>{t('dashboard.onboardingCandidate.contentPersonalData.textOption3')}</div>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentPersonalData.paragraph3')}}></div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.idealPosition')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentIdealPosition.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentIdealPosition.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <div><strong>{t('dashboard.onboardingCandidate.contentIdealPosition.option1')}</strong></div>
                        <div className='mb-3'>{t('dashboard.onboardingCandidate.contentIdealPosition.textOption1')}</div>
                        <div><strong>{t('dashboard.onboardingCandidate.contentIdealPosition.option2')}</strong></div>
                        <div className='mb-3'>{t('dashboard.onboardingCandidate.contentIdealPosition.textOption2')}</div>
                        <div><strong>{t('dashboard.onboardingCandidate.contentIdealPosition.option3')}</strong></div>
                        <div>{t('dashboard.onboardingCandidate.contentIdealPosition.textOption3')}</div>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentIdealPosition.paragraph3')}}></div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.disponibility')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentDisponibility.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentDisponibility.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <div><strong>{t('dashboard.onboardingCandidate.contentDisponibility.option1')}</strong></div>
                        <div className='mb-3'>{t('dashboard.onboardingCandidate.contentDisponibility.textOption1')}</div>
                        <div><strong>{t('dashboard.onboardingCandidate.contentDisponibility.option2')}</strong></div>
                        <div className='mb-3'>{t('dashboard.onboardingCandidate.contentDisponibility.textOption2')}</div>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentDisponibility.paragraph3')}}></div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.resume')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.paragraph1')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <div><strong>{t('dashboard.onboardingCandidate.contentResume.option1')}</strong></div>
                        <div className='mb-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.textOption1a')}}></div>
                        <ul>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.subOption1a')}}></li>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.subOption1b')}}></li>
                        </ul>
                        <div className='mb-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.textOption1b')}}></div>
                        <div><strong>{t('dashboard.onboardingCandidate.contentResume.option2')}</strong></div>
                        <div className='mb-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.textOption2')}}></div>
                        <ul>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.subOption2a')}}></li>
                            <li dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.subOption2b')}}></li>
                        </ul>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentResume.paragraph2')}}></div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}

export function OnBoardingCandidateProcess() {
    const { t } = useTranslation()
    return (
        <Accordion className='onboarding'>
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.video')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentVideo.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentVideo.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ul>
                            <li>{t('dashboard.onboardingCandidate.contentVideo.option1')}</li>
                            <li>{t('dashboard.onboardingCandidate.contentVideo.option2')}</li>
                        </ul>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.interview')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentInterview.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentInterview.paragraph2')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentInterview.paragraph3')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ul>
                            <li>{t('dashboard.onboardingCandidate.contentInterview.option1')}</li>
                            <li>{t('dashboard.onboardingCandidate.contentInterview.option2')}</li>
                            <li>{t('dashboard.onboardingCandidate.contentInterview.option3')}</li>

                        </ul>
                    </div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentInterview.paragraph4')}}></div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.offerLetter')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentOfferLetter.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentOfferLetter.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ol>
                            <li>{t('dashboard.onboardingCandidate.contentOfferLetter.option1')}</li>
                            <li>{t('dashboard.onboardingCandidate.contentOfferLetter.option2')}</li>
                            <ul>
                                <li>{t('dashboard.onboardingCandidate.contentOfferLetter.option2a')}</li>
                                <li>{t('dashboard.onboardingCandidate.contentOfferLetter.option2b')}</li>
                            </ul>
                            <li>{t('dashboard.onboardingCandidate.contentOfferLetter.option3')}</li>
                        </ol>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
                <Accordion.Header>
                    <img src="/images/puntoonboarding.svg" alt="Punto" className='me-4'/>
                    {t('dashboard.onboardingCandidate.incorporation')}
                </Accordion.Header>
                <Accordion.Body>
                    <div className='my-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentIncorporation.paragraph1')}}></div>
                    <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.contentIncorporation.paragraph2')}}></div>
                    <div className='my-3 bloque-puntos'>
                        <ol>
                            <li>{t('dashboard.onboardingCandidate.contentIncorporation.option1')}</li>
                            <li>{t('dashboard.onboardingCandidate.contentIncorporation.option2')}</li>
                            <li>{t('dashboard.onboardingCandidate.contentIncorporation.option3')}</li>
                        </ol>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}